import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/components/index.vue')
  }, {
    path: '/home',
    name: 'Home',
    component: Home
  }, {
    path: '/projects',
    name: 'Projects',
    component: () => import('@/views/Projects.vue')
  }, {
    path: '/viewpoints',
    name: 'Viewpoints',
    component: () => import('@/views/Viewpoints.vue')
  }, {
    path: '/publications',
    name: 'Publications',
    component: () => import('@/views/Publications.vue')
  }, {
    path: '/events',
    name: 'Events',
    component: () => import('@/views/Events.vue')
  }, {
    path: '/services',
    name: 'Services',
    component: () => import('@/views/Services.vue')
  }, {
    path: '/country',
    name: 'Country',
    component: () => import('@/views/Country.vue')
  }, {
    path: '/countryInfo',
    name: 'CountryInfo',
    component: () => import('@/views/CountryDetail.vue')
  }, {
    path: '/company',
    name: 'Company',
    component: () => import('@/views/Company.vue')
  }, {
    path: '/privacyPolicy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/PrivacyPolicy.vue')
  }, {
    path: '/termsOfUse',
    name: 'TermsOfUse',
    component: () => import('@/views/TermsOfUse.vue')
  }, {
    path: '/disclaimers',
    name: 'Disclaimers',
    component: () => import('@/views/Disclaimers.vue')
  }, {
    path: '/*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
